import api from '../services/api';

class FileManagerUtils {
  static checkFileExtension = (
    file: File,
    setErrors: (errors: any) => void,
    isVideoFile?: boolean,
  ) => {
    let allowedExtensions = ['pdf', 'jpeg', 'jpg', 'png'];
    if (isVideoFile) allowedExtensions = ['mp4', 'webm'];

    const extension = file.name.split('.').pop();

    if (!allowedExtensions.includes(extension as string)) {
      setErrors({ file: [`File extension is not allowed. Allowed extensions are: ${allowedExtensions.join(', ')}`] });
      console.error('File extension is not allowed');
      return false;
    }

    return true;
  };

  static async checkIfFileExists(
    endpoint: string,
    fileName: string,
    fn: () => void,
    setModalProperties: (properties: { isOpen: boolean; fn: () => void }) => void,
    overwriteFile: (fileId: number) => void,
  ) {
    const result = await api.get(`${endpoint}?searchTerm=${fileName}`);

    if (result.data.data.length === 0) {
      fn();
    } else {
      // get existing file id
      const fileId = result.data.data[0].id;

      console.log('File already exists. Overwrite?', fileId);

      setModalProperties({
        isOpen: true,
        fn: () => {
          overwriteFile(fileId);
        },
      });
    }
  }
}

export default FileManagerUtils;
